// import { Group } from '@shared/types/common';

// import { Toggle } from './toggle';
import cn from 'classnames';
import { Toggle } from '@widgets/shared/Publication/ui/ui/toggle-publication/toggle/ui.tsx';
import { Card } from '@shared/ui';
import * as st from './styles.module.scss';

type Props = {
  title: string;
  withLine?: boolean;
  isToggleOn?: boolean;
  onToggleClick?: () => void;
};

export const PublicationToggle: React.FC<Props> = ({
  title,
  withLine,
  onToggleClick,
  isToggleOn,
}) => {
  return (
    <Card className={cn(st.all, withLine && st.withRightLine)}>
      {withLine && <div className={st.rightLine}></div>}
      <p className={st.title}>{title}</p>
      <Toggle className={st.toggle} isToggleOn={isToggleOn} onClick={onToggleClick} />
    </Card>
  );
};
